export default "__VITE_ASSET__C4wQRClg__"